import React from "react";

const IThump = ({
  color = "#252526",
  width = "14",
  height = "14",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M2.1875 11.8124H3.64583V6.27072H2.1875V11.8124ZM4.52083 11.9582C4.52083 12.3609 4.19437 12.6874 3.79167 12.6874H2.04167C1.63896 12.6874 1.3125 12.3609 1.3125 11.9582V6.12488C1.3125 5.72218 1.63896 5.39572 2.04167 5.39572H3.79167C4.19437 5.39572 4.52083 5.72217 4.52083 6.12488V11.9582Z"
        fill={color}
      />
      <path
        d="M6.66618 1.47417C6.78639 1.34439 6.97043 1.2924 7.14071 1.3403L7.22445 1.37277L7.37883 1.45822C8.12845 1.91359 8.52852 2.78859 8.36947 3.66338L8.10742 5.10405H11.9179C12.358 5.10409 12.6977 5.49134 12.6408 5.92778L11.8421 12.0528C11.7947 12.4158 11.4848 12.6874 11.1187 12.6874H5.31885C5.27357 12.6874 5.22892 12.6611 5.18842 12.6105L4.08333 12.0579C3.73972 11.9838 3.64583 11.8323 3.64583 11.6665V6.41655C3.64583 6.33455 3.66903 6.25423 3.71248 6.1847L6.61206 1.54537L6.66618 1.47417ZM4.52083 6.54131V11.396L5.35311 11.8124H10.991L11.7515 5.97905H7.58333C7.4536 5.97905 7.33036 5.92142 7.24723 5.82182C7.16425 5.7223 7.12956 5.59101 7.15267 5.46351L7.50871 3.50672C7.58654 3.07867 7.43708 2.65084 7.13159 2.36398L4.52083 6.54131Z"
        fill={color}
      />
      <path
        d="M6.98297 1.77713C6.99263 1.76168 7.01245 1.75611 7.02874 1.76425C7.70307 2.10142 8.07395 2.84318 7.93908 3.66338L7.58333 5.54155H11.9178C12.0939 5.54155 12.2298 5.69636 12.207 5.87094L11.4081 11.9959C11.3892 12.1412 11.2654 12.2499 11.1189 12.2499H5.31885C5.27357 12.2499 5.22892 12.2393 5.18842 12.2191L4.08333 11.6665V6.41655L6.98297 1.77713Z"
        fill={color}
      />
    </svg>
  );
};

export default IThump;
